export const ELIF_DESCRIPTION =
  'Transform complex topics and concepts into simple explanations to make learning easy and fun.';
